'use strict';

import Form from '../../form/js/generic.form';


export default class CustomDonateForm extends Form {
    constructor(el, notLoggedSubmitHandler, isLoggedIn, ) {

        super(el);
        this.isLoggedIn = isLoggedIn;
        this.notLoggedSubmitHandler = notLoggedSubmitHandler;

    }

    beforeSubmit(e) {

        if (this.isLoggedIn) {
            if (this.parsleyForm.validate()) {
                window.__doPostBack(this.submit.getAttribute('data-clientid'), '');
            }
        } else {
            this.notLoggedSubmitHandler();
            this.submit.setAttribute('disabled','');
        }

    }
}



// WEBPACK FOOTER //
// ./app/components/custom-donate/js/custom-donate-form.js